import React from "react";

const ReprocessIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3873 11.0389L16.9346 10.5884L15.6898 8.43229L15.026 8.681C14.2923 8.95586 13.4902 8.49274 13.3614 7.71992L13.2448 7.02075H10.7552L10.6387 7.71996C10.5099 8.49274 9.70779 8.95586 8.9741 8.68104L8.31024 8.43233L7.06543 10.5884L7.61273 11.039C8.21759 11.5369 8.21759 12.4632 7.61273 12.9611L7.06543 13.4116L8.31024 15.5677L8.9741 15.319C9.70775 15.0442 10.5099 15.5073 10.6387 16.2801L10.7552 16.9793H13.2448L13.3614 16.28C13.4902 15.5072 14.2923 15.0441 15.026 15.319L15.6898 15.5677L16.9346 13.4116L16.3874 12.961C15.7825 12.4631 15.7825 11.5369 16.3873 11.0389ZM12 13.6598C11.0834 13.6598 10.3403 12.9166 10.3403 12C10.3403 11.0833 11.0834 10.3403 12 10.3403C12.9167 10.3403 13.6598 11.0833 13.6598 12C13.6598 12.9166 12.9167 13.6598 12 13.6598Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19 5C17.1575 3.14646 14.6121 2 11.8004 2C10.0643 2 8.43034 2.43823 7 3.20902"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17 20.791C15.5697 21.5618 13.9357 22 12.1996 22C9.38799 22 6.84251 20.8535 5 19"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19 19C20.8536 17.1574 22 14.612 22 11.8003C22 10.0642 21.5618 8.43033 20.7911 7"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 5C3.14646 6.84255 2 9.38803 2 12.1997C2 13.9358 2.43818 15.5697 3.20889 17"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.825 3L19 4.8391L17 5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 5.17497L4.83906 5L5 7"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.17497 21L5 19.1609L7 19"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21 18.825L19.1609 19L19 17"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ReprocessIcon;
